import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "se-ui-icon-google",
  "use": "se-ui-icon-google-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"se-ui-icon-google\">\n  <title id=\"se-ui-icon-google_title\">google</title>\n  <desc id=\"se-ui-icon-google_desc\">Solid color Google logo</desc>\n  <meta name=\"keywords\" content=\"google\" />\n  <path stroke-width=\"0\" fill-rule=\"nonzero\" d=\"M21.882 10.305h-9.689v4.152h5.491c-.877 2.768-3.045 3.691-5.535 3.691A5.998 5.998 0 1 1 16 7.558l3.017-2.876A10.15 10.15 0 1 0 12.15 22.3c5.597 0 10.658-3.69 9.733-11.995z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol